<div class="main-container">
  <div class="header">
    <div class="logo">
      @if (logoUrl) {
        <img [src]="logoUrl"
          alt="org logo">
        }
      </div>
      <div class="title">
        <h1>{{'customer_feedback_form' | translate}}</h1>
        <span>{{'feedback_form_msg' | translate}}</span>
      </div>
    </div>
    <mat-progress-bar mode="determinate"
    [value]="successOrErrorPage ? 100 : ((currentStep) / steps.length * 100)"></mat-progress-bar>
    <div class="content-wrapper">
      @if (!successOrErrorPage) {
        <div
          class="content"
          [formGroup]="feedbackForm">
          @for (step of steps; track step; let i = $index) {
            <div
              [hidden]="i !== currentStep"
              [formGroupName]="step.group"
              class="step">
              @for (input of step.input; track input) {
                @if (input.questionType === 'info') {
                  <div
                    class="info-box">
                    @if (input.icon) {
                      <mat-icon
                      [svgIcon]="'lock'"></mat-icon>
                    }
                    {{ input.question }}
                  </div>
                }
                @if (input.questionType === 'infoWithValue') {
                  <div
                    class="info-box">
                    @if (input.icon) {
                      <mat-icon
                      [svgIcon]="'lock'"></mat-icon>
                    }
                    <span [innerHTML]="input.question"></span>
                  </div>
                }
                @if (input.questionType === 'phoneNumber') {
                  <div
                    class="input-wrapper">
                    <label class="form-label uppercase"
                      for="">{{'enter_mobile_number' | translate}} <span class="required">*</span></label>
                      <div class="control-wrapper">
                        <xa-select formControlName="countryCode"
                          [config]="{name: 'countryCode', showRequiredLabel: true, showHeaderIcon: true}"
                        [options]="countryList"></xa-select>
                        <xa-text formControlName="mobileNumber"></xa-text>
                      </div>
                      @if (getControl(step.group, 'mobileNumber').errors && getControl(step.group, 'mobileNumber').touched) {
                        <span
                          class="error">
                          @if (feedbackForm.get(step.group).get('mobileNumber').errors['required']) {
                            <span>{{'mobile_number_required' | translate}}</span>
                          }
                          @if (feedbackForm.get(step.group).get('mobileNumber').errors['pattern']) {
                            <span>{{'enter_valid_mobile_number' | translate}}</span>
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (input.questionType === 'textbox') {
                    <div
                      class="input-wrapper">
                      <xa-text [formControlName]="input.questionCode"
                        [label]="input.question"
                      [required]="true"></xa-text>
                      @if (getControl(step.group, input.questionCode).errors && getControl(step.group, input.questionCode).touched) {
                        <span
                          class="error">
                          @if (feedbackForm.get(step.group).get(input.questionCode).errors['required']) {
                            <span>{{'field_required' | translate}}</span>
                          }
                          @if (feedbackForm.get(step.group).get(input.questionCode).errors['pattern']) {
                            <span>{{'only_alphanumeric_characters_are_allowed' | translate}}</span>
                          }
                          @if (feedbackForm.get(step.group).get(input.questionCode).errors['maxlength']) {
                            <span>{{'only_12_characters_allowed' | translate}}</span>
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (input.questionType === 'text') {
                    <div
                      class="input-wrapper input-wrapper-textarea-final">
                      <xa-textarea [label]="input.question"
                        [formControlName]="input.questionCode"
                        [placeholder]="input.question"
                        [name]="input?.questionCode"
                        [maxLength]="1000"
                        [required]="true"
                        class="text-area-feedback"
                      [rows]="3"></xa-textarea>
                      @if (getControl(step.group, input.questionCode).errors && getControl(step.group, input.questionCode).touched) {
                        <span
                          class="error">
                          @if (feedbackForm.get(step.group).get(input.questionCode).errors['required']) {
                            <span>{{'field_required' | translate}}</span>
                          }
                          @if (feedbackForm.get(step.group).get(input.questionCode).errors['maxlength']) {
                            <span>{{'only_1000_characters_allowed' | translate}}</span>
                          }
                        </span>
                      }
                    </div>
                  }
                  @if (input.questionType === 'rating' || input.questionType === 'choice') {
                    <div class="input-wrapper rating-wrapper">
                      @if (input.image) {
                        <img
                          [src]="input.image"
                          alt="Rating">
                      }
                      <span class="rating-title">
                        <span [innerHTML]="input.question"></span>
                        <span class="required">*</span>
                      </span>
                      <div class="rating-input-wrapper">
                        @if (input.questionType === 'rating') {
                          <div
                            class="thumb thumb-down">
                            <mat-icon [svgIcon]="'thumb-down'"></mat-icon>
                            <span>{{ input.labels?.leftText }}</span>
                          </div>
                        }
                        <xa-radio-group [formControlName]="input.questionCode"
                          [name]="input.questionCode"
                          [required]="true"
                          class="radio-group-display-flex">
                          @for (item of input.options; track item) {
                            <xa-radio [value]="item"
                              >
                              <span class="label-with-icon"
                                [ngClass]="{'yes': item === 'Yes', 'no': (item === 'No'  || item === ' No'), 'not-sure': (item === 'Not Sure' || item === ' Not Sure')}">
                                {{ item }}
                                @if (input.questionType === 'choice') {
                                  <mat-icon
                                  [svgIcon]="item === 'Yes' ? 'thumb-up' : (item === 'No' || item === ' No' ? 'thumb-down' : 'not-sure')"></mat-icon>
                                }
                              </span>
                            </xa-radio>
                          }
                        </xa-radio-group>
                        @if (input.questionType === 'rating') {
                          <div
                            class="thumb thumb-up">
                            <mat-icon [svgIcon]="'thumb-up'"></mat-icon>
                            <span>{{ input.labels?.rightText }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            }
            <div class="footer">
              @if (currentStep < steps.length - 1) {
                <a
                  (click)="nextStep()">
                  <xa-button [disabled]="!this.feedbackForm.get(this.steps[this.currentStep].group).valid">
                    <span> {{'next' | translate }}</span>
                  </xa-button>
                </a>
              }
              @if (currentStep === steps.length - 1) {
                <a
                  (click)="submitForm()">
                  <xa-button [disabled]="!this.feedbackForm.get(this.steps[this.currentStep].group).valid">
                    <span> {{'submit' | translate }}</span>
                  </xa-button>
                </a>
              }
              @if (currentStep !== 0) {
                <a
                  (click)="previousStep()">
                  <xa-button type="outline"
                    color="gray">
                    <span> {{'back' | translate }}</span>
                  </xa-button>
                </a>
              }
            </div>
          </div>
        }

        @if (successOrErrorPage) {
          <div
            class="content">
            <div class="step">
              <div class="input-wrapper rating-wrapper">
                <img [src]="successOrErrorPage === 'success' ? 'assets/img/feedback/image-5.png' : 'assets/img/feedback/image-6.png'"
                  alt="Success">
                  @if (successOrErrorPage === 'success') {
                    <span
                      class="rating-title">
                      <p>{{'thank_you' | translate}}</p>
                      <p>{{'success_saved_feedback' | translate}}..</p>
                    </span>
                  }
                  @if (successOrErrorPage === 'error') {
                    <span
                      class="rating-title">
                      <p>{{'already_saved_feedback' | translate}}..</p>
                      <p>{{'thank_you' | translate}}</p>
                    </span>
                  }
                </div>
              </div>
              <div class="footer"
                style="justify-content: center;">
                <a href="/">
                  <xa-button>
                    <span> {{'okay' | translate }}</span>
                  </xa-button>
                </a>
              </div>
            </div>
          }
        </div>
      </div>